import React, { Component } from 'react';
import {  AppHeaderDropdown,AppSidebarToggler} from '@coreui/react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav} from "reactstrap";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import md_logo from  '../../assets/img/logos/md-logo.png';

class EventTagHeader extends Component {

  render(){
    return(
      <React.Fragment>

        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <h1 className={"logo-text"}><span style={{color:'#53bd52'}}><img src={ md_logo } alt="" width={30}/></span>{ " " }Event</h1>

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px'
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>
              {/*<img src={usrProPic} className="img-avatar" alt="..."/>*/}
            </DropdownToggle>
            <DropdownMenu right style={{right: 'auto'}}>
              <DropdownItem onClick={e => this.props.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>

      </React.Fragment>

    );
  }
}

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  system_changer: state.systemChangeReducer.system_changer,
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EventTagHeader);

